/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Snapshot_History_Restore_ErrorInputs */



/**
* | output |
* | --- |
* | "Unable to restore commit: {message}" |
*
* @param {Snapshot_History_Restore_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_restore_error = /** @type {((inputs: Snapshot_History_Restore_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Restore_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
	return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
});